import { OrderType } from '@vista-digital/ocapi-types/v1'
import type { CompletedSubscriptionOrder } from '@vista-digital/ocapi-types/v1/types/orders/completed-orders/completed-subscription-order'

export function isCompletedSubscriptionOrder(order: unknown): order is CompletedSubscriptionOrder {
    if (!order || typeof order !== 'object') return false

    return 'type' in order && order.type === OrderType.Subscription
}
